import Alert from 'components/ui/base/alert/Alert';

const AlertUploadDocuments = () => {
    return <Alert message={'Revenue has requested documents to be uploaded'} closable type="warning" showIcon />;
};
export default AlertUploadDocuments;
